<template>
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9 3c0 1.5 1.3 3 3 3s3-1.5 3-3" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
<path d="M7 6c-2.5 2-4 5-4 8 0 4.5 4 7 9 7s9-2.5 9-7c0-3-1.5-6-4-8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12 9v8M10 12.3c0-.9.9-1.3 2-1.3s2 .4 2 1.3-.9 1.4-2 1.4-2 .5-2 1.4.9 1.3 2 1.3 2-.4 2-1.3" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>
